import { FeathersModel } from './feathersModel'

export class EventTypeSelect extends FeathersModel {
  static readonly serviceName = 'features/event-type-select'

  id: number
  name: string
  description: string
  code: string
}
